import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-wavesurfer";
import "videojs-wavesurfer/dist/css/videojs.wavesurfer.css";
import "./video.css";

const options = {
  inactivityTimeout: 0,
  width: "100%",
  height: 75,
  audioOnlyMode: true,
  plugins: {
    // wavesurfer: {
    //   container: "#waveform",
    //   waveColor: "#b4b4b4",
    //   progressColor: "#25AAE1",
    //   height: 75,
    //   responsive: true,
    //   cursorColor: "#EA5069",
    //   cursorWidth: 3,
    // },
  },
};

export const VideoWave = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { onReady } = props;

  React.useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement("video-js");

      videoElement.className = "video-js vjs-default-skin";

      videoRef.current.appendChild(videoElement);
      const player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player);
        player.src({ src: props.video });
      }));

      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      //const player = playerRef.current;
      //player.src({src: 'hal.wav', type: 'audio/wav'});
    }
  }, [options, videoRef, props.video]);

  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player={false}>
      <div ref={videoRef} />
    </div>
  );
};

export default VideoWave;
